import { render, staticRenderFns } from "./JobManager.vue?vue&type=template&id=2c848014&scoped=true&"
import script from "./JobManager.vue?vue&type=script&lang=js&"
export * from "./JobManager.vue?vue&type=script&lang=js&"
import style0 from "./JobManager.vue?vue&type=style&index=0&id=2c848014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c848014",
  null
  
)

export default component.exports